<div class="center-div">
  <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
</div>
